import { createSlice } from '@reduxjs/toolkit';

const itemsSlice = createSlice({
  name: 'items',
  initialState: {
    clickedItem: null,
  },
  reducers: {
    setClickedItem: (state, action) => {
      state.clickedItem = action.payload;
    },
  },
});

// Export the action creator
export const { setClickedItem } = itemsSlice.actions;

// Selector to get the clicked item
export const selectClickedItem = (state) => state.items.clickedItem;

// Export the reducer
export default itemsSlice.reducer;